// extracted by mini-css-extract-plugin
module.exports = {"paginator-mini":"paginator-mini__WUoQS"};